import Post from "../Post";
import getToken from "../token";

export default function getTutorialsOfCategory(
  id,
  limit = 10,
  page = 1,
  language
) {
  return Post("blog/blogsOfCategory", {
    token: getToken(),
    id: id,
    limit: limit,
    page: page,
    language: language,
  });
}
